import {Factory} from './Factory'
import Menu from '../EditorComponents/Banner/Menu'

export class BannerFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('banner'),
      iconContainerId: this.id('banner-icon-container'),
      iconId: this.id('banner-icon'),
      textId: this.id('banner-text'),
      ctaId: this.id('banner-cta'),
      slug: 'editor-banner',
      "assets": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "background": {
        "phone": "color",
        "tablet": "color",
        "desktop": "color"
      },
      "customClasses": [],
      "constantClasses": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "containerClasses":{
        "phone": [],
        "tablet": [],
        "desktop":[]
      },
      "name":"Banner",
    }
  }

  properties() {
    return {
      content: [
        {key: 'has-icon', component:'ContentToggle', text:'has an Icon', property:'hasIcon'},
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'has-cta', component:'ContentToggle', text:'has a CTA', property:'hasCTA'},
        {key: 'is-closable', component:'ContentToggle', text:'is closable', property:'isClosable'}
      ],
      styles: [
        {key: 'banner-position', component:'BannerPositionProperty'},
        {key: 'background-color', component:'BackgroundProperty', only: ['color']},
        {key: 'border', component:'BorderProperty'},
        {key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
      ],
      iconStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class: 'iconContainerClasses', styles:'iconContainerStyles'},
        {key: 'border', component:'BorderProperty', class:'iconContainerClasses', styles: 'iconContainerStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'iconContainerClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'iconStyles'},
      ],
      ctaStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], styles:'ctaStyles'},
        {key: 'border', component:'BorderProperty', class:'ctaClasses', styles: 'ctaStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'ctaClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'ctaStyles'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}